import React from 'react';
import {ModelDTO} from 'hemwb-api';
import {Grid} from '@mui/material';
import styles from './ModelOverview.module.scss';
import ModelRequestAccessButton from '../ModelRequestAccess/ModelRequestAccessButton';
import {
  canViewModelFiles,
  canViewModelFolders,
  checkExternalSecurityAPI,
} from '../../../../../permissions/usePermissions';
import {isModelRetired, useModelDetail, isModelTheorem} from '../../../../../store/model';
import {ButtonType} from 'antd/es/button';

type ModelOverviewRequestAccessProps = {
  model: ModelDTO;
  fromDynamicSearch?: boolean;
  THModel?: boolean;
  displayAntDesign?: boolean;
  width?: string;
  type?: ButtonType;
};

const ModelOverviewRequestAccess: React.FC<ModelOverviewRequestAccessProps> = ({
  model,
  fromDynamicSearch,
  THModel,
  displayAntDesign,
  width,
  type,
}) => {
  const isTheorem = isModelTheorem(model);

  const shouldFetchDetail = isTheorem || (!fromDynamicSearch && !displayAntDesign);
  const modelDetail = useModelDetail(shouldFetchDetail ? model : null) || undefined;

  const requestAccess = THModel
    ? !canViewModelFolders(model) && !checkExternalSecurityAPI(modelDetail)
    : !canViewModelFiles(model);

  if (!requestAccess || isModelRetired(model)) {
    return null;
  }

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      {!fromDynamicSearch && !displayAntDesign && (
        <div className={styles.requestAccessText}>
          You can only preview general information of this model.
          <br />
          To view further details or download this model, please request access
        </div>
      )}

      <div style={{width: width ?? undefined}}>
        <ModelRequestAccessButton
          fromDynamicSearch={fromDynamicSearch}
          displayAntDesign={displayAntDesign}
          model={model}
          modelDetail={modelDetail}
          type={type}
          width={width}
        />
      </div>
    </Grid>
  );
};

export default ModelOverviewRequestAccess;
